// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2ZZGD","flex":"flex___2rxKO","label":"label___33X7k","full":"full___LA5qo"};